import { InterFrameBilMsg, InterFrameCmd } from '../interframe-global.model';

export type OtherMessage = `${InterFrameCmd}other-${string}`;

export type OtherHandlerMsgOneReq =
    InterFrameBilMsg<'interframe-other-msg-one'>;
export type OtherHandlerMsgTwoReq = InterFrameBilMsg<
    'interframe-other-msg-two',
    { id: number }
>;
export type OtherHandlerMsgThreeReq = InterFrameBilMsg<
    'interframe-other-msg-three',
    { name: string }
>;
export type OtherHandlerMsgFourReq = InterFrameBilMsg<
    'interframe-other-msg-four',
    { startDate: Date }
>;

export type OtherHandlerMsgFiveReq =
    InterFrameBilMsg<'interframe-other-msg-five'>;

export type OtherHandlerMsgReqUnion =
    | OtherHandlerMsgOneReq
    | OtherHandlerMsgTwoReq
    | OtherHandlerMsgThreeReq
    | OtherHandlerMsgFourReq
    | OtherHandlerMsgFiveReq;

/**
 * Extract the message literal types from MyBizMessages
 * This type will be a union of all the possible message values
 */
type OtherHandlerMessageTypes = OtherHandlerMsgReqUnion['Command'];

/**
 * Type guard to check if a value is of type MyBizMessages
 * @param value The value to check (must be an InterFrameBilMsg<string>)
 * @returns True if the value is a valid MyBizMessages type, false otherwise
 */
export const isOtherHandlerMessages = (
    value: InterFrameBilMsg<OtherMessage>
): value is OtherHandlerMsgReqUnion => {
    // Type assertion to check if the message is one of the valid message types
    // This approach automatically works with any new messages added to MyBizMessages
    return isMessageType(value.Command);
};

/**
 * Helper type guard to check if a string is a valid MyBizMessageTypes
 * @param message The message string to check
 * @returns True if the message is a valid MyBizMessageTypes
 */
const isMessageType = (
    message: string
): message is OtherHandlerMessageTypes => {
    // This is a type-safe way to check if a string is in the union type
    // TypeScript will ensure this stays in sync with MyBizMessageTypes
    switch (message) {
        case 'interframe-other-msg-one':
        case 'interframe-other-msg-two':
        case 'interframe-other-msg-three':
        case 'interframe-other-msg-four':
        case 'interframe-other-msg-five':
            return true;
        default:
            return false;
    }
};
